import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { memo } from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import MealRoundedIcon from 'svg/meal-rounded.svg';
import UnionIcon from 'svg/union.svg';
import styles from './Meal.pcss';
const Meal = ({ carbs, imageHref })=>{
    useStyles(styles);
    const renderImage = ()=>{
        if (!imageHref) {
            return /*#__PURE__*/ _jsx("g", {
                transform: "translate(0, 24)",
                children: /*#__PURE__*/ _jsx(MealRoundedIcon, {
                    className: styles.meal__icon,
                    width: "48",
                    height: "32"
                })
            });
        }
        return /*#__PURE__*/ _jsxs("g", {
            transform: "translate(0, 24)",
            children: [
                /*#__PURE__*/ _jsx("image", {
                    preserveAspectRatio: "xMidYMid slice",
                    width: "48",
                    height: "32",
                    className: styles.meal__image,
                    xlinkHref: imageHref
                }),
                /*#__PURE__*/ _jsx("rect", {
                    width: "48",
                    height: "32",
                    rx: "6",
                    fill: "none",
                    stroke: "#FFFFFF",
                    strokeWidth: "5"
                })
            ]
        });
    };
    return(// translate element by half of its width to center element on axisX
    /*#__PURE__*/ _jsxs("g", {
        className: styles.meal,
        transform: "translate(-24)",
        children: [
            renderImage(),
            /*#__PURE__*/ _jsxs("g", {
                transform: "translate(10)",
                children: [
                    /*#__PURE__*/ _jsx(UnionIcon, {
                        width: "2.6rem",
                        height: "2.2rem"
                    }),
                    /*#__PURE__*/ _jsx("g", {
                        transform: "translate(13, 13)",
                        children: /*#__PURE__*/ _jsx("text", {
                            className: styles.meal__text,
                            children: carbs
                        })
                    })
                ]
            })
        ]
    }));
};
export default /*#__PURE__*/ memo(Meal);
